// extracted by mini-css-extract-plugin
export default {"container":"styles_container__i+i0h","description":"styles_description__RXMVN","createButton":"styles_createButton__EzEMg","navigateButton":"styles_navigateButton__lo-Yu"};